import Highcharts from 'highcharts';
import { TCorrelationValue } from '../../../../types';

const ANALYSIS_TYPE_META: { key: string; label: string; symbol: string }[] = [
  { key: 'liao', label: 'Capillary Pressure', symbol: 'circle' },
  { key: 'water-oil', label: 'Water-Oil', symbol: 'square' },
  { key: 'gas-oil', label: 'Gas-Oil', symbol: 'triangle' },
];

export const buildAnalysisTypeLegendSeries = (
  permData: TCorrelationValue[],
  color: string
): Highcharts.SeriesOptionsType[] => {
  const presentTypes = new Set<string>();
  let hasMultiple = false;

  permData.forEach(p => {
    p.analysisTypes?.forEach(t => presentTypes.add(t));
    if ((p.analysisTypes?.length ?? 0) > 1) hasMultiple = true;
  });

  const series: Highcharts.SeriesOptionsType[] = [];

  ANALYSIS_TYPE_META.forEach(({ key, label, symbol }) => {
    if (!presentTypes.has(key)) return;
    series.push({
      type: 'scatter',
      id: `legend-analysis-${key}`,
      name: label,
      data: [],
      color,
      marker: { symbol, radius: 5, enabled: true },
      showInLegend: true,
      enableMouseTracking: false,
    } as Highcharts.SeriesScatterOptions);
  });

  if (hasMultiple) {
    series.push({
      type: 'scatter',
      id: 'legend-analysis-multiple',
      name: 'Multiple types',
      data: [],
      color,
      marker: { symbol: 'diamond', radius: 5, enabled: true },
      showInLegend: true,
      enableMouseTracking: false,
    } as Highcharts.SeriesScatterOptions);
  }

  return series;
};
